module.exports = __webpack_public_path__ + "static/img/5.1.ca9cd1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/5.1.png
// module id = +MWq
// module chunks = 0